<template>
    <div>
        <o-field label="Job # *" :type="fieldType('dob_job_number')" :message="getError('dob_job_number')">
            <o-input placeholder="Job #" v-model="form.dob_job_number"/>
        </o-field>

        <o-field label="Location # *" :type="fieldType('location')" :message="getError('location')">
            <o-input placeholder="Location #" v-model="form.location"/>
        </o-field>

        <o-field label="Status *" :type="fieldType('status')" :message="getError('status')">
            <o-select placeholder="Select a status" v-model="form.status" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="status in inspectionsStatuses"
                    :value="status.id"
                    :key="status.id">
                    {{ status.name }}
                </option>
            </o-select>
        </o-field>
    </div>
</template>

<script>
    import Application from '../../../mixins/Application'
    import HandlesForm from '../../../mixins/HandlesForm'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [Application, HandlesForm],

        data () {
            return {
                form: {
                    application_number: null,
                    dob_job_number: null,
                    location: null,
                    status: null
                }
            }
        },

        computed: {
            ...mapGetters({
                inspectionsStatuses: 'inspectionsStatuses'
            })
        }
    }
</script>
